import { MdDownloadForOffline } from "react-icons/md";
import useGeneralStore from "../../App/Store/GeneralStore";
import { PiFilePdfFill } from "react-icons/pi";

export default function DownloadCv() {
    const { isDarkMode } = useGeneralStore();
    return (
        <div
            className={`bg-transparent group cursor-pointer rounded-md w-[120px] sm:w-[170px] h-8 flex items-center justify-center overflow-hidden ${
                isDarkMode
                    ? ""
                    : ""
            }`}
        >
            <a
                href="https://dub.sh/zamanshahed"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 text-sm font-semibold bg-transparent dark:text-cDarkText w-full h-full rounded-md"
            >
                <span className="sm:block hidden">Download</span>
                <span className="sm:hidden block">
                    <MdDownloadForOffline size={22} />
                </span>
                <span>CV</span>
                <PiFilePdfFill size={22} />
            </a>
        </div>
    );
}
